import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/jobbkarta/Footer";

export default function LegalLayout({ title, updated, testid, children }) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="sticky top-0 z-[1100] border-b border-slate-200 bg-white/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between gap-3 px-4 sm:px-6">
          <Link
            to="/"
            data-testid="legal-logo"
            className="font-display text-xl font-extrabold tracking-tight text-slate-900"
          >
            Spontan<span className="text-emerald-600">.</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-3 py-1.5 text-sm text-slate-600 transition-colors hover:bg-slate-50"
          >
            <ArrowLeft className="h-4 w-4" /> Till startsidan
          </Link>
        </div>
      </header>

      <main
        data-testid={testid}
        className="mx-auto w-full max-w-3xl flex-1 px-4 py-12 sm:px-6"
      >
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          {title}
        </h1>
        {updated && (
          <p className="mt-2 text-sm text-slate-400">Senast uppdaterad: {updated}</p>
        )}
        <div className="legal-prose mt-8 space-y-6 text-[15px] leading-relaxed text-slate-700">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="space-y-2">
      <h2 className="font-display text-lg font-semibold text-slate-900">{heading}</h2>
      {children}
    </section>
  );
}
